/* global $ */
import React, { PropTypes }   from 'react';
import { isLocal, envCheck }  from 'utils/util';


export default React.createClass({
  displayName: 'MedscapeTV.Transcript',
  propTypes: {
    videoUrlFragment: PropTypes.string.isRequired
  },
  getDefaultProps: function() {
    return {
      videoUrlFragment: null
    };
  },
  getInitialState() {
    return {
      itsHTML: undefined
    };
  },
  componentDidMount() {
    const url = isLocal()? 'sample-transcript.html' : `http://www${envCheck()}.medscape.com/mtv/${window.MedscapeTVInstance.seriesUrlFragment}/transcript-${this.props.videoUrlFragment}`;
    $.get(url).done(function(data) {
      document.getElementById('transcript-content').innerHTML = data;
    })
    .fail(function() {
      document.getElementById('transcript-content').innerHTML = '';
    });
  },
  shouldComponentUpdate(nextProps) {
    return (nextProps.videoUrlFragment !== this.props.videoUrlFragment);
  },
  componentDidUpdate() {
    const url = isLocal()? 'sample-transcript.html' : `http://www${envCheck()}.medscape.com/mtv/${window.MedscapeTVInstance.seriesUrlFragment}/transcript-${this.props.videoUrlFragment}`;
    $.get(url).done(function(data) {
      document.getElementById('transcript-content').innerHTML = data;
    })
    .fail(function() {
      document.getElementById('transcript-content').innerHTML = '';
    });
  },
  createMarkup() { return {__html: this.state.itsHTML };},
  render() {
    return (<div></div>);
  }
});



/** WEBPACK FOOTER **
 ** ./modules/components/medscape_tv/transcript.jsx
 **/